
<app-navbar></app-navbar>

<main >
  <section class="header relative pt-16 items-center flex mt-36 ">
    <div class="container mx-auto px-4 ">
      <div class="items-center flex flex-wrap justify-center ">
        <h3 class="font-semibold tracking-wide text-2xl lg:text-3xl  text-center info-color">Frequently Asked Questions</h3>
      </div>
      <p class=" text-xl lg:text-2xl mt-4 info-color text-center  leading-10">Have any questions we haven’t answered yet? Get in touch!</p>
      <div class="mx-auto max-w-7xl ">
        <div class="mx-auto max-w-4xl divide-y divide-gray-900/10">

          <dl class="mt-10 space-y-6 divide-y divide-gray-900/10" x-data="{ expanded: false }">
            <div class="pt-6">

              <dt>
                <!-- Expand/collapse question button -->
                <button type="button" class="flex w-full items-start justify-between text-left text-gray-900"
                  aria-controls="faq-0" x-on:click="expanded = !expanded">
                  <span class="text-base font-semibold leading-7">How can I download Banan? </span>
                  <span class="ml-6 flex h-7 items-center">

                    <!-- Icon when question is collapsed -->
                    <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                      x-bind:class="{ 'hidden': expanded, '': !expanded }">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m6-6H6" />
                    </svg>

                    <!-- Icon when question is expanded -->
                    <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                      x-bind:class="{ '': expanded, 'hidden': !expanded }">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M18 12H6" />
                    </svg>
                  </span>
                </button>
              </dt>
              <dd class="mt-2 pr-12" id="faq-0" x-bind:class="{ 'hidden': !expanded }">
                <ol class="list-decimal list-inside space-y-4">
                  <li class="text-base leading-7 text-gray-600">
                    <span class="font-semibold text-primary">Access Your App Store:</span>
                    Open the App Store on your device (Google Play for Android or App Store for iOS).
                  </li>
                  <li class="text-base leading-7 text-gray-600">
                    <span class="font-semibold text-primary">Search for "Banan":</span>
                    In the search bar, type "Banan" to find the official app.
                  </li>
                  <li class="text-base leading-7 text-gray-600">
                    <span class="font-semibold text-primary">Verify the Developer:</span>
                    Ensure the app is published by "Banan" to confirm its authenticity.
                  </li>
                  <li class="text-base leading-7 text-gray-600">
                    <span class="font-semibold text-primary">Download and Install:</span>
                    Tap the "Install" or "Download" button to get the app on your device.
                  </li>
                  <li class="text-base leading-7 text-gray-600">
                    <span class="font-semibold text-primary">Register and Explore:</span>
                    After installation, open the app, register using your phone number, and complete the quick verification process to start using Banan's features.
                  </li>
                </ol>
              </dd>
            </div>

            <!-- More questions... -->
          </dl>
          <dl class="mt-10 space-y-6 divide-y divide-gray-900/10" x-data="{ expanded: false }">
            <div class="pt-6">

              <dt>
                <!-- Expand/collapse question button -->
                <button type="button" class="flex w-full items-start justify-between text-left text-gray-900"
                  aria-controls="faq-0" x-on:click="expanded = !expanded">
                  <span class="text-base font-semibold leading-7">Where can I use Banan? </span>
                  <span class="ml-6 flex h-7 items-center">

                    <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                      x-bind:class="{ 'hidden': expanded, '': !expanded }">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m6-6H6" />
                    </svg>

                    <!-- Icon when question is expanded -->
                    <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                      x-bind:class="{ '': expanded, 'hidden': !expanded }">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M18 12H6" />
                    </svg>
                  </span>
                </button>
              </dt>
              <dd class="mt-2 pr-12" id="faq-0" x-bind:class="{ 'hidden': !expanded }">
                <p class="text-base leading-7 text-gray-600">You can be used Banan across our registered sectors like government, finance, healthcare, and private enterprises to enable secure data exchange, seamless communication, and efficient identity verification.</p>
              </dd>
            </div>

            <!-- More questions... -->
          </dl>

          <dl class="mt-10 space-y-6 divide-y divide-gray-900/10" x-data="{ expanded: false }">
            <div class="pt-6">

              <dt>
                <!-- Expand/collapse question button -->
                <button type="button" class="flex w-full items-start justify-between text-left text-gray-900"
                  aria-controls="faq-0" x-on:click="expanded = !expanded">
                  <span class="text-base font-semibold leading-7">I no longer want to share my data with specific clients, what should I do?</span>
                  <span class="ml-6 flex h-7 items-center">

                    <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                      x-bind:class="{ 'hidden': expanded, '': !expanded }">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m6-6H6" />
                    </svg>

                    <!-- Icon when question is expanded -->
                    <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                      x-bind:class="{ '': expanded, 'hidden': !expanded }">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M18 12H6" />
                    </svg>
                  </span>
                </button>
              </dt>
              <dd class="mt-2 pr-12" id="faq-0" x-bind:class="{ 'hidden': !expanded }">
                <ol class="list-decimal list-inside space-y-4">
                  <li class="text-base leading-7 text-gray-600">
                    <span class="font-semibold text-primary">Log In to Your Banan Account:</span>
                    Open the Banan app and sign in using your credentials.
                  </li>
                  <li class="text-base leading-7 text-gray-600">
                    <span class="font-semibold text-primary">Access Your Data Sharing Settings:</span>
                    Navigate to the settings or privacy section within your account.
                  </li>
                  <li class="text-base leading-7 text-gray-600">
                    <span class="font-semibold text-primary">Select the Client:</span>
                    Find the specific client or organization you want to stop sharing data with.
                  </li>
                  <li class="text-base leading-7 text-gray-600">
                    <span class="font-semibold text-primary">Revoke Data Sharing Permissions:</span>
                    Click on the option to revoke or disable data sharing for that client.
                  </li>
                  <li class="text-base leading-7 text-gray-600">
                    <span class="font-semibold text-primary">Confirm Your Action:</span>
                    Confirm the changes to ensure your data is no longer accessible to the selected client.
                  </li>
                </ol>
                <p class="text-base leading-7 text-gray-900 mt-4">If you encounter any issues, reach out to Banan’s support team for further assistance.</p>
              </dd>
            </div>

            <!-- More questions... -->
          </dl>
          <dl class="mt-10 space-y-6 divide-y divide-gray-900/10" x-data="{ expanded: false }">
            <div class="pt-6">

              <dt>
                <!-- Expand/collapse question button -->
                <button type="button" class="flex w-full items-start justify-between text-left text-gray-900"
                  aria-controls="faq-0" x-on:click="expanded = !expanded">
                  <span class="text-base font-semibold leading-7">How can I contact Banan support if I have problem? </span>
                  <span class="ml-6 flex h-7 items-center">

                    <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                      x-bind:class="{ 'hidden': expanded, '': !expanded }">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m6-6H6" />
                    </svg>

                    <!-- Icon when question is expanded -->
                    <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                      x-bind:class="{ '': expanded, 'hidden': !expanded }">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M18 12H6" />
                    </svg>
                  </span>
                </button>
              </dt>
              <dd class="mt-2 pr-12" id="faq-0" x-bind:class="{ 'hidden': !expanded }">
                <p class="text-base leading-7 text-gray-600">If you encounter any issues or require assistance with Banan Trust Service Provider, you can reach out to their support team through the following methods:</p>

                <ol class="list-decimal list-inside space-y-6">
                  <li class="text-base leading-7 text-gray-600">
                    <span class="font-semibold text-primary">In-App Support:</span>
                    <ul class="list-disc ml-6 space-y-2">
                      <li>Open the Banan app on your device.</li>
                      <li>Navigate to the 'Help' section, typically found in the settings menu.</li>
                      <li>Use the available options to contact support directly or access the FAQ for common issues.</li>
                    </ul>
                  </li>
                  
                  <li class="text-base leading-7 text-gray-600">
                    <span class="font-semibold text-primary">Official Website:</span>
                    <ul class="list-disc ml-6 space-y-2">
                      <li>Visit <a href="http://www.banan.om" class="primary-color hover:underline">www.banan.om</a>.</li>
                      <li>Locate the 'Contact Us' page, usually linked to the bottom of the homepage.</li>
                      <li>Fill out the contact form with your details and a description of the issue.</li>
                    </ul>
                  </li>
                  
                  <li class="text-base leading-7 text-gray-600">
                    <span class="font-semibold text-primary">Email Support:</span>
                    <ul class="list-disc ml-6 space-y-2">
                      <li>Send an email detailing your problem to Banan's support team at <a href="mailto:info@banan.com" class="primary-color hover:underline">info@banan.com</a>.</li>
                      <li>Include relevant information such as your account details and any error messages to facilitate prompt assistance.</li>
                    </ul>
                  </li>
                  
                  <li class="text-base leading-7 text-gray-600">
                    <span class="font-semibold text-primary">Phone Support:</span>
                    <ul class="list-disc ml-6 space-y-2">
                      <li>Call Banan's customer service on <a href="tel:+98624967868" class="primary-color hover:underline">+986 24967868</a>.</li>
                      <li>Provide your account information and a clear description of the issue to receive immediate support.</li>
                    </ul>
                  </li>
                </ol>
          
              </dd>
            </div>
          </dl>

        </div>
      </div>
    </div>
  </section>
  <section class="h-150-px">


  </section>

</main>
<app-footer></app-footer>
